import axios from 'axios';
import qs from 'qs';

export const baseURL = process.env.REACT_APP_BASE_URL;
export const wsURL = process.env.REACT_APP_WS_URL;
export const nylasConnectUrl = process.env.REACT_APP_NYLAS_CONNECT_URL;
export const appsignalApiKey = process.env.REACT_APP_APPSIGNAL_API_KEY;

export default axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
  paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
});
export const instance = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
  paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
});